import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import useStyles from "./styles";
import { useSelector } from "react-redux";
import CircleIcon from "@mui/icons-material/Circle";

const stakeholders = [
  "Investor",
  "Employee",
  "Business partner",
  "NGO",
  "Customer",
  "Community Member",
];
const levels = ["Poor", "Average", "Good", "Best"];

export default function ZigZagGraph({ stakeholderGroups }) {
  const classes = useStyles();

  const zigZagGraphSelect = useSelector(
    (state) => state.materiality.materialityZigZagGraph
  );
  const zigZagStatus = zigZagGraphSelect.status;
  const zigZagData = zigZagGraphSelect.data?.zig_zag_data;
  const zigZagInsights = zigZagGraphSelect.data?.insights || {};
  const [data, setData] = useState({});
  // const [stakeholderGroups, setStakeholderGroups] = useState(
  //   stakeholders.slice(0, 3)
  // );
  const aspectMap = {
    "Importance of the topic": "Importance",
    "Understanding and awareness": "Understanding",
    "Effectiveness of current practices": "Execution",
    "Future readiness and improvement plans": "Future",
  };

  const transformData = (data) => {
    const resultMap = {};

    for (const stakeholder in data) {
      const stakeholderData = data[stakeholder];

      for (const category in stakeholderData) {
        const topics = stakeholderData[category];

        if (!resultMap[category]) resultMap[category] = {};

        for (const topic in topics) {
          if (!resultMap[category][topic]) {
            resultMap[category][topic] = {};
          }

          const aspects = topics[topic];
          for (const aspect in aspects) {
            if (!resultMap[category][topic][aspect]) {
              resultMap[category][topic][aspect] = {};
            }

            resultMap[category][topic][aspect][stakeholder] = aspects[aspect];
          }
        }
      }
    }
    console.log(resultMap, "result");

    return resultMap;
  };

  useEffect(() => {
    setData(transformData(zigZagData));
  }, [zigZagData]);
  return (
    <>
      {zigZagData && Object.keys(zigZagData).length ? (
        <>
          <div className={classes.zMain}>
            <div className={classes.scaleMatrix}>
              <Typography style={{ paddingLeft: "5px" }}>
                0-2 : Poor,
              </Typography>
              <Typography style={{ paddingLeft: "5px" }}>
                2-3 : Average,
              </Typography>
              <Typography style={{ paddingLeft: "5px" }}>
                3-4 : Good,
              </Typography>
              <Typography style={{ paddingLeft: "5px" }}>4-5 : Best</Typography>
            </div>
            <div className={classes.zSub}>
              <table className={classes.zTable}>
                <thead>
                  <tr>
                    <th
                      className={classes.cellStyleWithoutBorder}
                      // style={{ minWidth: "102px" }}
                    ></th>
                    <th
                      className={classes.cellStyleWithoutBorder2}
                      // style={{ minWidth: "102px" }}
                    ></th>
                    <th
                      className={classes.cellStyleWithoutBorder3}
                      // style={{ minWidth: "128px" }}
                    ></th>
                    {stakeholderGroups?.map((group) => (
                      <th
                        key={group}
                        colSpan={4}
                        className={classes.cellStyleCase}
                        style={{
                          border: "None",
                          textAlign: "center",
                          color: dotColor(group),
                        }}
                      >
                        <div className={classes.zTableHeaderStake}>
                          <Box className={classes.zHorizontalLine} />
                          {group}
                          <Box className={classes.zHorizontalLine} />
                        </div>
                      </th>
                    ))}
                  </tr>
                  <tr>
                    <th className={classes.cellStyleWithoutBorder}></th>
                    <th className={classes.cellStyleWithoutBorder2}></th>
                    <th className={classes.cellStyleWithoutBorder3}></th>
                    {stakeholderGroups?.map((group) =>
                      levels?.map((level) => (
                        <th
                          key={`${group}-${level}`}
                          className={classes.cellStyleCase}
                          style={{
                            border: "None",
                          }}
                        >
                          {level}
                        </th>
                      ))
                    )}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(data)?.map((main, mainIndex) => {
                    const topicItems = Object.keys(data[main]);

                    return topicItems?.map((topicItem, topicIndex) => {
                      const aspects = Object.keys(data[main][topicItem]);

                      return aspects?.map((aspect, aspectIndex) => {
                        return (
                          <tr key={`${main}-${topicItem}-${aspect}`}>
                            {topicIndex === 0 && aspectIndex === 0 && (
                              <td
                                rowSpan={aspects.length * topicItems.length}
                                className={classes.verticalText}
                                style={{
                                  fontWeight: "bold",
                                  // backgroundColor: "white",
                                  // border: "1px solid #ccc",
                                }}
                              >
                                {main}
                              </td>
                            )}
                            {aspectIndex === 0 && (
                              <td
                                rowSpan={aspects.length}
                                className={classes.cellStyleWithoutBorder2}
                                style={{
                                  fontWeight: "bold",
                                  backgroundColor: "white",
                                  border: "1px solid #ccc",
                                }}
                              >
                                {topicItem}
                              </td>
                            )}
                            <td
                              className={classes.cellStyleWithoutBorder3}
                              style={{
                                fontWeight: 500,
                                border: "1px solid #ccc",
                              }}
                            >
                              {aspectMap[aspect]}
                            </td>
                            {stakeholderGroups?.map((group) => {
                              const score =
                                data?.[main]?.[topicItem]?.[aspect]?.[group] ||
                                0;

                              const dotCells = Array(4).fill(null);
                              if (
                                typeof score === "number" &&
                                score >= 2 &&
                                score <= 5
                              ) {
                                dotCells[score - 2] = true;
                              } else if (score == 1) {
                                dotCells[0] = true;
                              }
                              return dotCells?.map((hasDot, i) => (
                                <td
                                  key={`${group}-${aspect}-${i}`}
                                  className={classes.cellStyleCase}
                                  style={{
                                    position: "relative",
                                    padding: 4,
                                  }}
                                >
                                  {hasDot && (
                                    <div
                                      className={classes.dot}
                                      style={{
                                        backgroundColor: dotColor(group),
                                      }}
                                    />
                                  )}
                                </td>
                              ));
                            })}
                          </tr>
                        );
                      });
                    });
                  })}
                </tbody>
              </table>

              <svg className={classes.svgStyle} width="100%" height="100%">
                {stakeholderGroups?.map((group, groupIdx) => {
                  const points = [];
                  let yOffset = 100; // Approx row height and header offset
                  Object.keys(data).forEach((main) => {
                    Object.keys(data[main]).forEach((topic) => {
                      Object.keys(data[main][topic]).forEach((aspect) => {
                        const score = data[main][topic][aspect][group];

                        if (
                          typeof score === "number" &&
                          score >= 2 &&
                          score <= 5
                        ) {
                          const x =
                            372 + groupIdx * 4 * 70 + (score - 2) * 70 + 40; // x-position of column center
                          const y = yOffset;
                          points.push({ x, y });
                          yOffset += 40.8;
                        } else if (score === 1) {
                          const x = 372 + groupIdx * 4 * 70 + 0 * 70 + 40; // x-position of column center
                          const y = yOffset;
                          points.push({ x, y });
                          yOffset += 40.8;
                        } else {
                          yOffset += 40.8;
                        }
                      });
                    });
                  });

                  return (
                    <polyline
                      key={group}
                      points={points?.map((p) => `${p.x},${p.y}`).join(" ")}
                      fill="none"
                      stroke={dotColor(group)}
                      strokeWidth={2}
                    />
                    //   <></>
                  );
                })}
              </svg>
            </div>
          </div>
          <div className={classes.zigZagCommonSuggestion}>
            <Typography className={classes.headings} variant="h6">
              Zig-Zag Graph Key Insights & Recommendations
            </Typography>
            {Object.keys(zigZagInsights)?.map((head) => {
              return (
                <div>
                  <div className={classes.dispDiv}>
                    <CircleIcon
                      style={{
                        width: "10px",
                        height: "10px",
                        marginRight: "10px",
                      }}
                    />
                    <Typography className={classes.mainContentText}>
                      {head}
                    </Typography>
                  </div>
                  {zigZagInsights[head]?.["description"] && (
                    <div style={{ marginTop: "8px" }}>
                      <Typography
                        className={classes.mainContentText}
                      ></Typography>
                      <Typography>
                        {zigZagInsights[head]["description"]}
                      </Typography>
                    </div>
                  )}
                  <div style={{ paddingLeft: "20px" }}>
                    <span className={classes.dispDiv}>
                      <Typography className={classes.mainContentText}>
                        Why it matter:{" "}
                      </Typography>
                      <Typography>{zigZagInsights[head]?.["why"]}</Typography>
                    </span>
                    <div>
                      <Typography className={classes.mainContentText}>
                        Suggestions
                      </Typography>
                      {zigZagInsights[head]?.["suggestions"]?.map(
                        (sug, idx) => {
                          return (
                            <Typography>
                              {idx + 1}. {sug}
                            </Typography>
                          );
                        }
                      )}
                    </div>

                    <div style={{ marginTop: "8px" }}>
                      <Typography className={classes.mainContentText}>
                        Topic:
                      </Typography>
                      <Typography>
                        {Array.isArray(zigZagInsights[head]?.["topic"])
                          ? zigZagInsights[head]["topic"].join(", ")
                          : zigZagInsights[head]?.["topic"] || "-"}
                      </Typography>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      ) : (
        <div className={classes.zMain}>
          <Typography className={classes.headings} variant="h6">
            Zig-Zag Graph Data is not available
          </Typography>
        </div>
      )}
    </>
  );
}

const dotColor = (group) => {
  switch (group) {
    case "Employee":
      return "#007bff";
    case "Investor":
      return "#28a745";
    case "Business partner":
      return "#dc3545";
    case "Customer":
      return "#a3b635ff";
    case "NGO":
      return "#ec70c1ff";
    default:
      return "#6c757d";
  }
};
